import { SelectItem } from '@wui/common-library'
import { computed } from 'vue'

import { useLocalization } from '@/shared/composables/localization'

import { TypesOfNotification } from './'

/** Типы уведомлений, связанные с сообщениями/чатами (скрываются без InstantMessaging). */
export const MESSAGE_RELATED_NOTIFICATION_TYPES: TypesOfNotification[] = [
  TypesOfNotification.GROUP_CHATS_MESSAGE,
  TypesOfNotification.P2P_CHATS_MESSAGE,
  TypesOfNotification.MENTION_AND_QUOTE,
  TypesOfNotification.PIN_MESSAGE,
  TypesOfNotification.ROOM_CREATING,
]

/** Типы уведомлений о вызовах (остаются в combobox без InstantMessaging). */
export const CALL_RELATED_NOTIFICATION_TYPES: TypesOfNotification[] = [
  TypesOfNotification.GROUP_CHATS_CALL,
  TypesOfNotification.P2P_CALL,
]

export const isMessageRelatedNotification = (type: TypesOfNotification): boolean =>
  MESSAGE_RELATED_NOTIFICATION_TYPES.includes(type)

export const isCallRelatedNotification = (type: TypesOfNotification): boolean =>
  CALL_RELATED_NOTIFICATION_TYPES.includes(type)

export const items = computed<SelectItem<TypesOfNotification>[]>(() => {
  const { t } = useLocalization()
  return [
    {
      label: t('common.groupChatsMessages'),
      value: TypesOfNotification.GROUP_CHATS_MESSAGE,
    },
    {
      label: t('common.privateChatsMessages'),
      value: TypesOfNotification.P2P_CHATS_MESSAGE,
    },
    {
      label: t('common.mentionAndQuote'),
      value: TypesOfNotification.MENTION_AND_QUOTE,
    },
    {
      label: t('common.groupChatsCalls'),
      value: TypesOfNotification.GROUP_CHATS_CALL,
    },
    {
      label: t('common.privateChatsCalls'),
      value: TypesOfNotification.P2P_CALL,
    },
    {
      label: t('common.pinMessage'),
      value: TypesOfNotification.PIN_MESSAGE,
    },
    {
      label: t('common.roomCreating'),
      value: TypesOfNotification.ROOM_CREATING,
    },
  ]
})
